<template>
  <div class="products-individuals-wrapper">
    <IndividualsHeader :el="'ch'" />
    <div class="text-group">
      <h3 class="text-ch">{{ $t('products-ch-1') }}</h3>
      <p>{{ $t('products-ch-2') }}</p>
      <p>{{ $t('products-ch-3') }}</p>
    </div>
    <Gallery :gallery="gallery" />
    <div class="content-row" id="alloysElement">
      <Dropdown
        :id="'chDropdownOne'"
        :color="color"
        :title="$t('products-ch-dd1-1')"
        :content="dropdownOne"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Dropdown
        :id="'chDropdownTwo'"
        :color="color"
        :title="$t('products-ch-dd2-1')"
        :content="dropdownTwo"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Dropdown
        :id="'chdropdownThree'"
        :color="color"
        :title="$t('products-ch-dd3-1')"
        :content="dropdownThree"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Dropdown
        :id="'chdropdownFour'"
        :color="color"
        :title="$t('products-ch-dd4-1')"
        :content="dropdownFour"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Files :color="color" :files="files" />
    </div>
  </div>
</template>

<script>
import IndividualsHeader from './shared/IndividualsHeader';
import Gallery from './shared/Gallery';
import Dropdown from './shared/Dropdown';
import Files from './shared/Files';
export default {
  components: {
    IndividualsHeader,
    Gallery,
    Dropdown,
    Files
  },
  props: ['color'],
  data() {
    return {
      gallery: [
        {
          type: 'image',
          url: require('../../../assets/img/products/ch/ch_gallery_1.jpg')
        },
        {
          type: 'image',
          url: require('../../../assets/img/products/ch/ch_gallery_2.jpg')
        },
        {
          type: 'image',
          url: require('../../../assets/img/products/ch/ch_gallery_3.jpg')
        },
        {
          type: 'image',
          url: require('../../../assets/img/products/ch/ch_gallery_4.jpg')
        },
        {
          type: 'image',
          url: require('../../../assets/img/products/ch/ch_gallery_5.jpg')
        }
      ],
      files: {
        bg: [
          'Брошура КЦМ Сярна киселина.pdf',
          'Брошура КЦМ Кадмий.pdf',
          'Кадмий-Информационен лист за безопасност.pdf',
          'Сярна киселина-Информационен лист за безопасност.pdf',
          'Телур-Информационен лист за безопасност.pdf'],
        en: [
          'Brochure KCM Sulfuric acid.pdf',
          'Brochure KCM Cadmium.pdf',
          'H2SO4 SDS.pdf',
          'Tellurium SDS.pdf',
          'Cadmium SDS.pdf'
        ]
      }
    };
  },
  computed: {
    dropdownOne() {
      return {
        table: [
          [
            this.$t('products-ch-dd1-2'),
            this.$t('products-ch-dd1-3'),
            this.$t('products-ch-dd1-4'),
            this.$t('products-ch-dd1-5')
          ],
          [this.$t('products-ch-dd1-6'), '95.0 ÷ 98.3', '93.5 ÷ 94.5', '96.3'],
          [this.$t('products-ch-dd1-7'), '0,01', '0,03', '0,01'],
          [this.$t('products-ch-dd1-8'), '0,003', '0,005', '0,0009'],
          [this.$t('products-ch-dd1-9'), '0,00001', '0,0001', '0,00001'],
          [this.$t('products-ch-dd1-10'), '0,0005', '0,001', '0,00007'],
          [this.$t('products-ch-dd1-11'), '0,0005', '0,001', '0,0005'],
          [this.$t('products-ch-dd1-15'), this.$t('products-ch-dd1-16'), this.$t('products-ch-dd1-16'), this.$t('products-ch-dd1-16')]
        ],
        columns: {
          left: [
            {
              img: require('../../../assets/img/products/ch/dd1.jpg')
            }
          ],
          right: [
            {
              texts: [this.$t('products-ch-dd1-12')]
            },
            {
              title: this.$t('products-ch-dd1-13'),
              texts: [this.$t('products-ch-dd1-14')]
            }
          ]
        }
      };
    },
    dropdownTwo() {
      return {
        table: [
          [this.$t('brand'), '99.93'],
          [this.$t('elements'), '%'],
          [{ el: 'Te' }, '99.9 min.'],
          [{ el: 'Se' }, '0.05 max.'],
          [{ el: 'Cu' }, '0.05 max.'],
          [{ el: 'Pb' }, '0.005 max.'],
          [{ el: 'S' }, '0.005 max.'],
          [{ el: 'Si' }, '0.001 max.'],
          [{ el: 'Sb' }, '0.002 max.'],
          [{ el: 'As' }, '0.0001 max.'],
          [{ el: 'Ag' }, '0.005 max.'],
          [{ el: 'Hg' }, '0.001 max.'],
          [{ el: 'Zn' }, '0.005 max.'],
          [{ el: 'Fe' }, '0.001 max.'],
          [{ el: 'Na' }, '0.005 max.'],
          [this.$t('products-dd-9'), '0.1 max.']
        ],
        columns: {
          left: [
            {
              img: require('../../../assets/img/products/ch/dd2.jpg')
            }
          ],
          right: [
            {
              spec: {
                title: this.$t('products-dd-1'),
                mass: '3,1 - 3,2 kg',
                left: this.$t('products-dd-3'),
                right: this.$t('products-dd-5'),
                l: '220 mm',
                w: '50 mm',
                h: '50 mm'
              }
            },
            {
              title: this.$t('products-ch-dd2-2'),
              texts: [this.$t('products-ch-dd2-3')]
            },
            {
              title: this.$t('products-ch-dd2-4'),
              texts: [this.$t('products-ch-dd2-5')]
            }
          ]
        }
      };
    },
    dropdownThree() {
      return {
        table: [
          [this.$t('brand'), '99.95'],
          [this.$t('elements'), '%'],
          [{ el: 'Cd' }, '99.95 min.'],
          [{ el: 'Zn' }, '0.01 max.'],
          [{ el: 'Pb' }, '0.025 max.'],
          [{ el: 'Fe' }, '0.002 max.'],
          [{ el: 'Cu' }, '0.01 max.'],
          [{ el: 'Tl' }, '0.005 max.'],
          [this.$t('products-ch-dd3-2'), '0.05 max.']
        ],
        columns: {
          left: [
            {
              img: require('../../../assets/img/products/ch/dd3.jpg')
            }
          ],
          right: [
            {
              spec: {
                title: this.$t('products-dd-1'),
                mass: '4,2 - 4,3 kg',
                left: this.$t('products-dd-3'),
                right: this.$t('products-dd-5'),
                l: '145 mm',
                w: '50 mm',
                h: '45 mm'
              }
            },
            {
              spec: {
                title: this.$t('products-ch-dd3-5'),
                mass: '800 - 820 kg',
                left: this.$t('products-ch-dd3-4'),
                right: this.$t('products-dd-5'),
                l: '750 mm',
                w: '550 mm',
                h: '160 mm'
              }
            },
            {
              title: this.$t('products-ch-dd2-2'),
              texts: [this.$t('products-ch-dd3-3')]
            }
          ]
        }
      };
    },
    dropdownFour() {
      return {
        table: [
          [
            this.$t('products-ch-dd4-2'),
            'Parameters, % by weight',
            this.$t('products-ch-dd4-3'),
            this.$t('products-ch-dd4-4')
          ],
          [this.$t('products-ch-dd4-4'), 'Free moisture', '< 10', '8÷10'],
          [
            this.$t('products-ch-dd4-5'),
            'Calcium sulphate dehydrate',
            '> 95',
            '98.5'
          ],
          [
            this.$t('products-ch-dd4-6'),
            'Calcium sulphate semihydrate',
            '< 0.5',
            '0.2'
          ],
          [
            this.$t('products-ch-dd4-7'),
            'Magnesium oxide, total',
            '< 0.1',
            '0.08'
          ],
          [
            this.$t('products-ch-dd4-8'),
            'Magnesium oxide, water soluble',
            '< 0.05',
            '0.001'
          ],
          [
            this.$t('products-ch-dd4-9'),
            'Soldium oxide, water soluble',
            '< 0.05',
            '0.01'
          ],
          [this.$t('products-ch-dd4-10'), 'Chloride', '< 0.1', '0.015'],
          [
            this.$t('products-ch-dd4-11'),
            'Copper, lead, cadmium, zinc',
            '< 0.05',
            '0.01'
          ],
          [
            this.$t('products-ch-dd4-12'),
            'Arsenic, selenium, mercury',
            '< 0.005',
            '0.0008'
          ],
          [this.$t('products-ch-dd4-13'), 'pH', '6÷9', '6.4'],
          [
            this.$t('products-ch-dd4-14'),
            'Colour',
            this.$t('products-ch-dd4-15'),
            ''
          ]
        ],
        columns: {
          left: [
            {
              img: require('../../../assets/img/products/ch/dd4.jpg')
            }
          ],
          right: [
            {
              texts: [this.$t('products-ch-dd4-16')]
            },
            {
              title: this.$t('products-ch-dd4-17'),
              texts: [
                this.$t('products-ch-dd4-18'),
                this.$t('products-ch-dd4-19'),
                this.$t('products-ch-dd4-20'),
                this.$t('products-ch-dd4-21'),
                this.$t('products-ch-dd4-22'),
                this.$t('products-ch-dd4-23')
              ]
            }
          ]
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.products-individuals-wrapper {
  padding-bottom: 50px;
  .text-group {
    margin: 0 auto;
    padding-top: 40px;
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
  .content-row {
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
}
@media screen and (max-width: 1600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1440px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1280px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
  }
}
@media screen and (max-width: 1000px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
    .content-row {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
  }
}
@media screen and (max-width: 600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
    .content-row {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
  }
}
</style>

